"use strict";
/**
 * 法务条款的版本号与生效日期 —— **前端展示与后端记录共用这一处**。
 *
 * 为什么必须共用：注册时勾选同意，我们会在库里记下"同意的是哪一版"。
 * 如果官网页面写 v1.1、后端记的是 v1.0，那份记录就是错的，而且**错得看不出来**
 * （数据库里就是一个字符串，没有任何东西会对不上）。真出事时，
 * 我们能拿出的证据只有这个字符串。
 *
 * 改条款时三件事必须一起做，否则版本号会撒谎：
 *   1) 改这里的 `TERMS_VERSION` 与 `TERMS_EFFECTIVE`；
 *   2) 改 `platform-terms.tsx` 的正文；
 *   3) 想清楚老客户要不要重新确认（当前实现**不**拦截老会话，
 *      靠协议第 14 条"继续使用视为接受"兜底）。
 *
 * 版本号用 `v` + 主次号，不用日期：日期版本号在一天内改两稿时无法区分。
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRIVACY_EFFECTIVE = exports.PRIVACY_VERSION = exports.TERMS_EFFECTIVE = exports.TERMS_VERSION = void 0;
exports.formatLegalDate = formatLegalDate;
/** 服务条款当前版本 */
exports.TERMS_VERSION = 'v1.0';
/** 服务条款生效日期（ISO，展示时由页面格式化，避免各处手写中文日期写岔） */
exports.TERMS_EFFECTIVE = '2026-11-01';
/** 隐私政策当前版本。与条款分开走：政策改了不必让客户重签服务条款 */
exports.PRIVACY_VERSION = 'v1.0';
exports.PRIVACY_EFFECTIVE = '2026-11-01';
/** ISO 日期 → 「2026 年 11 月 1 日」。手写这个格式的地方超过三处，迟早会写成 2026-11-1 */
function formatLegalDate(iso) {
    const [year, month, day] = iso.split('-');
    if (!year || !month || !day)
        return iso;
    return `${year} 年 ${Number(month)} 月 ${Number(day)} 日`;
}
//# sourceMappingURL=legal.js.map